import { configureStore, createSlice } from '@reduxjs/toolkit'

let login = createSlice({
    name: 'login',
    initialState: { value: false },
    reducers: {
        checkLogin(state, action) {
            state.value = action.payload
        }
    }
})

let JWT = createSlice({
    name: 'JWT',
    initialState: { value: "" },
    reducers: {
        checkJWT(state, action) {
            state.value = action.payload
        }
    }
})

let jackpot = createSlice({
    name: 'jackpot',
    initialState: [],
    reducers: {
        checkJackpot(state, action) {
            return action.payload
        }
    }
})

let mySkin = createSlice({
    name: 'mySkin',
    initialState: [],
    reducers: {
        checkMySkin(state, action) {
            return action.payload
        }
    }
})

let myData = createSlice({
    name: 'myData',
    initialState: [],
    reducers: {
        checkMyData(state, action) {
            return action.payload
        }
    }
})

let haptic = createSlice({
    name: 'haptic',
    initialState: { value: true },
    reducers: {
        changeHaptic(state, action) {
            let now = action.payload
            localStorage.setItem('haptic', now)
            state.value = now
        }
    }
})

let sound = createSlice({
    name: 'sound',
    initialState: { value: true },
    reducers: {
        changeSound(state, action) {
            let now = action.payload
            localStorage.setItem('sound', now)
            state.value = now
        }
    }
})

let gold = createSlice({
    name: 'gold',
    initialState: { value: 0 },
    reducers: {
        changeGold(state, action) {
            state.value = action.payload
        }
    }
})

let energy = createSlice({
    name: 'energy',
    initialState: { value: 0 },
    reducers: {
        changeEnergy(state, action) {
            state.value = action.payload
        }
    }
})

let tapUpgrade = createSlice({
    name: 'tapUpgrade',
    initialState: { value: 1 },
    reducers: {
        checkTapUpgrade(state, action) {
            state.value = action.payload
        }
    }
})

let limitUpgrade = createSlice({
    name: 'limitUpgrade',
    initialState: { value: 1 },
    reducers: {
        checkLimitUpgrade(state, action) {
            state.value = action.payload
        }
    }
})

let tapUpgradeValue = createSlice({
    name: 'tapUpgradeValue',
    initialState: { value: 1 },
    reducers: {
        checkTapUpgradeValue(state, action) {
            state.value = action.payload
        }
    }
})

let limitUpgradeValue = createSlice({
    name: 'limitUpgradeValue',
    initialState: { value: 1 },
    reducers: {
        checkLimitUpgradeValue(state, action) {
            state.value = action.payload
        }
    }
})

let Languages = createSlice({
    name: 'Languages',
    initialState: { value: "en-US" },
    reducers: {
        changeLanguages(state, action) {
            localStorage.setItem("language", action.payload)
            state.value = action.payload
        }
    }
})

let alramModal = createSlice({
    name: 'alramModal',
    initialState: { value: 0 },
    reducers: {
        changeAlramModal(state, action) {
            state.value += 1
        }
    }
})

let mobileType = createSlice({
    name: 'mobileType',
    initialState: { value: "android" },
    reducers: {
        changeMobileType(state, action) {
            state.value = action.payload
        }
    }
})

let DuplicateLogins = createSlice({
    name: 'DuplicateLogins',
    initialState: { value: false },
    reducers: {
        checkDuplicateLogins(state, action) {
            state.value = action.payload
        }
    }
})

let PlusEnergy = createSlice({
    name: 'PlusEnergy',
    initialState: [],
    reducers: {
        changePlusEnergy(state, action) {
            return action.payload
        }
    }
})

let JackpotImg = createSlice({
    name: 'JackpotImg',
    initialState: [],
    reducers: {
        changeJackpotImg(state, action) {
            return action.payload
        }
    }
})

let FullScreenBtn = createSlice({
    name: 'FullScreenBtn',
    initialState: { value: false },
    reducers: {
        changeFullScreenBtn(state, action) {
            localStorage.setItem('FullScreen', action.payload)
            state.value = action.payload
        }
    }
})

let circleImg = createSlice({
    name: 'circleImg',
    initialState: { value: "" },
    reducers: {
        changeCircleImg(state, action) {
            state.value = action.payload
        }
    }
})

let backgroundImg = createSlice({
    name: 'backgroundImg',
    initialState: { value: "" },
    reducers: {
        changeBackgroundImg(state, action) {
            state.value = action.payload
        }
    }
})

export let { checkLogin } = login.actions
export let { checkJWT } = JWT.actions
export let { checkJackpot } = jackpot.actions
export let { checkMySkin } = mySkin.actions
export let { checkMyData } = myData.actions
export let { changeHaptic } = haptic.actions
export let { changeSound } = sound.actions
export let { changeGold } = gold.actions
export let { changeEnergy } = energy.actions
export let { checkTapUpgrade } = tapUpgrade.actions
export let { checkLimitUpgrade } = limitUpgrade.actions
export let { checkTapUpgradeValue } = tapUpgradeValue.actions
export let { checkLimitUpgradeValue } = limitUpgradeValue.actions
export let { changeLanguages } = Languages.actions
export let { changeAlramModal } = alramModal.actions
export let { changeMobileType } = mobileType.actions
export let { checkDuplicateLogins } = DuplicateLogins.actions
export let { changePlusEnergy } = PlusEnergy.actions
export let { changeJackpotImg } = JackpotImg.actions
export let { changeFullScreenBtn } = FullScreenBtn.actions
export let { changeCircleImg } = circleImg.actions
export let { changeBackgroundImg } = backgroundImg.actions

export default configureStore({
    reducer: {
        login: login.reducer,
        JWT: JWT.reducer,
        jackpot: jackpot.reducer,
        mySkin: mySkin.reducer,
        myData: myData.reducer,
        haptic: haptic.reducer,
        sound: sound.reducer,
        gold: gold.reducer,
        energy: energy.reducer,
        tapUpgrade: tapUpgrade.reducer,
        limitUpgrade: limitUpgrade.reducer,
        tapUpgradeValue: tapUpgradeValue.reducer,
        limitUpgradeValue: limitUpgradeValue.reducer,
        Languages: Languages.reducer,
        alramModal: alramModal.reducer,
        mobileType: mobileType.reducer,
        DuplicateLogins: DuplicateLogins.reducer,
        PlusEnergy: PlusEnergy.reducer,
        JackpotImg: JackpotImg.reducer,
        FullScreenBtn: FullScreenBtn.reducer,
        circleImg: circleImg.reducer,
        backgroundImg: backgroundImg.reducer,
    }
}) 